import { useState, useEffect } from "react";
import InfoIcon from '@mui/icons-material/Info';

/**
 * 
 * @returns 
 */
export default function CreditCardMonthYear(props) {

  const handleChange = (ev) => {
    ev.stopPropagation();
    let str = ev.target.value.replace(/[^\d]/g, ""); // Remove non-digits

    // Limit to 4 digits (MMYY)
    if (str.length > 4) str = str.slice(0, 4);

    // Auto-insert slash after 2 digits
    if (str.length > 2) {
      str = str.slice(0, 2) + "/" + str.slice(2);
    }

    // Call parent onChange if provided
    if (props.onChange) {
      // Create a synthetic event with formatted value
      props.onChange({ ...ev, target: { ...ev.target, value: str } });
    }

  }

  return (
    <input {...props} onChange={handleChange} />
  );
}
